import { useSyncExternalStore } from "react";

const emptySubscribe = () => () => {};

/**
 * Returns `false` during server-side rendering and hydration, and `true`
 * afterwards. Use it for anything that must be rendered identically on the
 * server and on the client and only become environment-specific (local
 * timezone, ...) after hydration.
 */
export function useHydrated(): boolean {
    // client snapshot has to differ from the server one for the re-render
    // after hydration to occur
    return useSyncExternalStore(
        emptySubscribe,
        () => true,
        () => false,
    );
}
